module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatInput"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "ieInputXClear",
    attrs: {
      "type": "text",
      "id": "chatInputArea",
      "placeholder": "메세지 입력하기",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.printMessage.apply(null, arguments)
      },
      "click": _vm.scrollBottom,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    style: (_vm.buttonStyle),
    attrs: {
      "id": "chatInputButton"
    },
    on: {
      "click": _vm.printMessage
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6746402a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-input.vue
// module id = 103
// module chunks = 0